import React from 'react';

import { AccountContext } from '../../../Context/AccountContext';
import { LocalCartContext } from '../../../Context/LocalCartContext';
import { ShopwareCartContext } from '../../../Context/ShopwareCartContext';
import PriceWithSpecialPrice from '../../../PriceWithSpecialPrice/PriceWithSpecialPrice';
import { ActionType, CartContextInterface, CartItemType } from '../../Types';

import './CartItem.scss';

interface Props {
    item: CartItemType;
    customerId?: string;
    linkToProduct?: boolean;
}

const CartItem: React.FunctionComponent<Props> = (props) => {
    const { isLoggedIn } = React.useContext(AccountContext);

    let updateCartItems: (updateItem: CartItemType, action: ActionType, customerId?: string) => void;

    const context: React.Context<CartContextInterface> = isLoggedIn ? ShopwareCartContext : LocalCartContext;
    ({ updateCartItems } = React.useContext(context));

    const removalClick = () => {
        updateCartItems(props.item, ActionType.Remove, props.customerId);
    };

    return (
        <div className="slide-in-cart__item cart-item">
            <a className="cart-item__link" href={props.linkToProduct !== false ? props.item.link : undefined}>
                <img className="cart-item__image" src={props.item.imageUri} />
                <div className="cart-item__details">
                    <strong>{props.item.quantity + 'x '}</strong>
                    {props.item.title}
                    <div className="cart-item__volume">{props.item.volume}</div>
                    <strong className="cart-item__price">
                        <PriceWithSpecialPrice price={props.item.price} specialPrice={props.item.specialPrice} />
                    </strong>
                </div>
            </a>

            <button type="button" className="cart-item__remove" onClick={removalClick}>
                <svg className="icon">
                    <use xlinkHref="#icon-close-borderless" />
                </svg>
            </button>
        </div>
    );
};

export default CartItem;
